export const FILES_FOR_UPLOAD = [
  {
    id: 1,
    text: 'Recibos de nómina',
    files: [
      {
        name: null,
        size: null,
        loader: false,
        text: '*Sube el PDF de tu primer recibo de nómina',
        filesAccept: 'pdf',
      },
      {
        name: null,
        size: null,
        loader: false,
        text: '*Sube el PDF de tu segundo recibo de nómina',
        filesAccept: 'pdf',
      },
    ],
  },
  {
    id: 2,
    text: 'Estados de cuenta',
    files: [
      {
        name: null,
        size: null,
        loader: false,
        text: '*Sube tu primer estado de cuenta',
      },
      {
        name: null,
        size: null,
        loader: false,
        text: '*Sube tu segundo estado de cuenta',
      },
      {
        name: null,
        size: null,
        loader: false,
        text: '*Sube tu tercer estado de cuenta',
      },
    ],
  },
  {
    id: 3,
    text: 'Declaración anual',
    files: [
      {
        name: null,
        size: null,
        loader: false,
        text: '*Sube tu primer declaración anual de impuestos',
      },
      {
        name: null,
        size: null,
        loader: false,
        text: '*Sube tu segunda declaración anual de impuestos',
      },
    ],
  },
];


export const buildFileVoucher = function (resp: any, clientId: any, sseId: any, email: any, templateId: number) {

  return {
    files: [
      {
        ...resp.comprobanteDomicilio,
        name: null,
        size: null,
        loader: false,
        templateId,
        clientId,
        email,
        folderId: '',
        referenceId: `${resp.comprobanteDomicilio.documentId}_0`,
        sseId,
        fileId: '',
      },
    ],
  }
}

export const buildFileFiscal = function (resp: any, clientId: any, sseId: any, email: any, templateId: number) {
  return {
    files: [
      {
        ...resp.comprobanteSituacionFiscal,
        name: null,
        size: null,
        loader: false,
        templateId,
        clientId,
        email,
        folderId: '',
        referenceId: `${resp.comprobanteSituacionFiscal.documentId}_0`,
        sseId,
        fileId: '',
      },
    ],
  }
}

export const buildFileDomicilation = function (resp: any, clientId: any, sseId: any, email: any, templateId: number) {
  return {
    files: [
      {
        ...resp.domiciliacion,
        name: null,
        size: null,
        loader: false,
        templateId,
        clientId,
        email,
        folderId: '',
        referenceId: `${resp.domiciliacion.documentId}_0`,
        sseId,
        fileId: '',
      },
    ],
  }
}

export const buildFileAnnual = function (resp: any, clientId: any, sseId: any, email: any, templateId: number) {
  return {
    files: [
      {
        ...resp.comprobanteIngreso[0],
        name: null,
        size: null,
        loader: false,
        templateId,
        clientId,
        email,
        folderId: '',
        referenceId: `${resp.comprobanteIngreso[0].documentId}_0`,
        sseId,
        fileId: '',
      },
    ],
  }
}

export const ID_PAY_STUBS = 1;
export const ID_ACCOUNT_STATEMENTS = 2;
export const ID_ANNUAL_STATEMENTS = 3;

export const generateOptionsFilePFA = function () {
  return [
    {
      id: ID_PAY_STUBS,
      text: 'Recibos de nómina',
      files: [],
      keyfilter: 'nomina'
    },
    {
      id: ID_ACCOUNT_STATEMENTS,
      text: 'Estados de cuenta',
      files: [
        generateVarFiles('*Sube tu primer estado de cuenta', null),
        generateVarFiles('*Sube tu segundo estado de cuenta', null),
        generateVarFiles('*Sube tu tercer estado de cuenta', null),
      ],
      keyfilter: 'cuenta'
    },
    {
      id: ID_ANNUAL_STATEMENTS,
      text: 'Declaración anual',
      files: [
        generateVarFiles('*Sube tu primer declaración anual de impuestos', null),
        generateVarFiles('*Sube tu segunda declaración anual de impuestos', null),
      ],
      keyfilter: 'declaracion'
    },
  ];
}

export const generateOptionsFilePFAE = function () {
  return [
    {
      id: ID_ACCOUNT_STATEMENTS,
      text: 'Estados de cuenta',
      files: [
        generateVarFiles('*Sube tu primer estado de cuenta', null),
        generateVarFiles('*Sube tu segundo estado de cuenta', null),
        generateVarFiles('*Sube tu tercer estado de cuenta', null),
        generateVarFiles('*Sube tu cuarto estado de cuenta', null),
      ],
      keyfilter: 'cuenta'
    },
  ];
}

export const generateOptionsFileFORD = function () {
  return [
    {
      id: ID_PAY_STUBS,
      text: 'Recibos de nómina',
      files: [],
      keyfilter: 'nomina'
    }
  ];
}

export const generateVarFiles = function (text: string, filesAccept: string | null) {
  let data: any = {
    name: null,
    size: null,
    loader: false,
    text
  }

  if (filesAccept)
    data.filesAccept = filesAccept;

  return data;
}

export const OPTIONS_TYPE_VOUCHER = [
  {
    id: 1,
    text: "Quincenales",
    files: [
      generateVarFiles('*Sube el PDF de tu primer recibo quincenal de nómina', 'pdf'),
      generateVarFiles('*Sube el PDF de tu segundo recibo quincenal de nómina', 'pdf'),
      generateVarFiles('*Sube el PDF de tu tercer recibo quincenal de nómina', 'pdf'),
      generateVarFiles('*Sube el PDF de tu cuarto recibo quincenal de nómina', 'pdf'),
    ],
    keyfilter: 'nomina'
  },
  {
    id: 2,
    text: "Mensuales",
    files: [
      generateVarFiles('*Sube el PDF de tu primer recibo mensual de nómina', 'pdf'),
      generateVarFiles('*Sube el PDF de tu segundo recibo mensual de nómina', 'pdf'),
    ],
    keyfilter: 'nomina'
  }
]

export const OPTIONS_TYPE_VOUCHER_FORD = [
  {
    id: 1,
    text: "Mensuales",
    files: [
      generateVarFiles('*Sube el PDF de tu primer recibo mensual de nómina', 'pdf'),
      generateVarFiles('*Sube el PDF de tu segundo recibo mensual de nómina', 'pdf'),
    ],
    keyfilter: 'nomina'
  }
]

export const QUERY_PARAMS = {
  QUOTER: ['quoterId','concept','period','event'],
  CREDIT: ['solicitud-de-credito']
}

export const QUOTER_NUMBER = {
  INITIAL:{
    NUMBER: "1",
    NAME: "Cotización inicial",
  },
  EVALUATE_RISK: {
    NUMBER: "2",
    NAME: "Cotización evaluación riesgo"
  },
  SELECTED_CAR: {
    NUMBER: "3",
    NAME: "Cotización auto seleccionado"
  }
}

export const DEFAULT_NAME_QUOTER = "Cotización detallada";

export const KM_30 = 30000;

export const KM_20 = 20000;

export const PERIODS = {
  SIX_MONTHS: 60
}

export const FLOW_LEASING_RENTING = 'LEASING_AND_RENTING'

export const FLOW_AFIN = 'AFIN';

export const FLOW_RR = 'RR'